import React from "react";
import { number } from "prop-types";

import "./headPhoneIcon.m.css";

const HeadPhoneIcon = ({ width = 15, height = 15 }) => (
  <div styleName="wrapper">
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 42 42">
      <path d="M0 0H42V42H0z" fill="transparent" />
      <g transform="translate(1.867 .933)">
        <path
          d="M25.133 2A19.074 19.074 0 0 0 6 21.011V35.8a6.362 6.362 0 0 0 6.378 6.337h6.378v-16.9h-8.5v-4.226a14.882 14.882 0 0 1 29.763 0v4.225h-8.5v16.9h6.378a6.362 6.362 0 0 0 6.37-6.336V21.011A19.074 19.074 0 0 0 25.133 2z"
          transform="translate(-6 -2)"
          fill="#35144f"
        />
      </g>
    </svg>
  </div>
);

HeadPhoneIcon.propTypes = {
  width: number,
  height: number,
};

export default HeadPhoneIcon;
